/**
 * The external dependencies.
 */
import React from 'react';
/**
 * The internal dependencies.
 */
import CloseButton from '../../components/task/close-button';
import Header from '../../components/task/shop/header';
import Text from '../../components/task/shop/text';
import {ts_translate} from "../../common/clientTranslate";

const Bar = ({longNumber, onClose, color = '#43abf3', task}) => (
    <Header color={color} textColor="#fff">
        <Text large>
            Produkt:
        </Text>

        <Text large>
            {ts_translate('ERP-Nr.')}: {longNumber}, {ts_translate('Owner-Nr.', false, true)}: {task.owningTaskErp ? task.owningTaskErp : '-'}
        </Text>

        <Text flex small>
            Schließen

            <CloseButton onClick={onClose}/>
        </Text>
    </Header>
);

export default Bar;



// WEBPACK FOOTER //
// ./src/components/task/bar.js